import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'productosFavoritos',
})
export class ProductosFavoritosPipe implements PipeTransform {

  transform(items: any[], filter: any[]) {

    if(filter['favorito']){

      items = items.filter(function(item) {

        return item.favorito;


      });

    }

    return items;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/productos-favoritos/productos-favoritos.ts